/** Достаёт первый video-трек из srcObject элемента (или undefined). */
export function getVideoTrack(video: HTMLVideoElement): MediaStreamTrack | undefined {
    const source = video.srcObject;
    if (source instanceof MediaStream) {
        return source.getVideoTracks()[0];
    }
    return undefined;
}
